<template>
  <div class="row">
    <div class="col-lg-2 col-md-5 part-tit">
      <h2 class="part-tit--name">
        {{mainTitle}}
      </h2>
    </div>
    <div class="col-lg-10 col-md-7 part-desc">
      <p class="part-desc--1">
        {{desc1}}
      </p>
      <p class="part-desc--2">
        {{desc2}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilmHeader',
  props: {
    mainTitle: {
      type: String,
      default: '',
    },
    desc1: {
      type: String,
      default: '',
    },
    desc2: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>

</style>
